/**
 * A language
 * @class
 * @property {string} language The name of the language
 * @property {number} level The level of the language
 * @property {boolean} isNative Whether the language is native
 * @property {boolean} certified Whether the language is certified
 */

export class Language {
  language: string = "";
  level: number = 0;
  isNative: boolean = false;
  isRequired: boolean = false;
  certified: boolean = false;
  constructor(language: string, level: number, isNative: boolean = false, isRequired: boolean = false, certified: boolean = false) {
    this.language = language;
    this.level = level;
    this.isNative = isNative;
    this.isRequired = isRequired;
    this.certified = certified;
  }

  /**
   * Get the skill level as a string
   * @returns {string} A string representation of the skill
   */
  toString() {
    return this.language + ' (' + this.level + ')';
  }

 static getLevelFromString(levelStr: string): number {
    switch (levelStr) {
        case 'A1':
            return 1;
        case 'A2':
            return 2;
        case 'B1':  
            return 3;
        case 'B2':
            return 4;
        case 'C1':
            return 5;
        case 'C2':
            return 6;   
        default:
            return 0;
    }
}

 static getLevelStringFromNumber(level: number): string {
    switch (level) {
        case 1:
            return 'A1';
        case 2:
            return 'A2';
        case 3:
            return 'B1';
        case 4:
            return 'B2';
        case 5:
            return 'C1';
        case 6:
            return 'C2';
        default:
            return 'Unknown';
    }
 }
}
